<div class="margin-all-area">
    <div class="home-dashboard-section">
        <div class="row-panel">
            <div class="col-left-panel" style="max-width:100%">
                <div class="wraper-main-section">
                    <div class="global-card-section">
                        <div class="global-body-section">
                            <div>
                                <table mat-table [dataSource]="vtOptionListSource" class="mat-elevation-z8" matSort (matSortChange)="_localService.setSortState($event, 'view_voiceTreeOptionList_grid')">
                                    <ng-container matColumnDef="digit">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> digit </th>
                                        <td mat-cell *matCellDef="let dataItem">
                                            <div class="customer-name">{{ dataItem.digit }}</div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Option </th>
                                        <td mat-cell *matCellDef="let dataItem">
                                            <div class="customer-name">{{ dataItem.name }}</div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="typeDisplay">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Transfer To </th>
                                        <td mat-cell *matCellDef="let dataItem">
                                            <div class="customer-name">
                                                <span>{{ dataItem.typeDisplay}}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <ng-container matColumnDef="valueDisplay">
                                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                                        <td mat-cell *matCellDef="let dataItem">
                                            <div class="customer-name">
                                                <span>{{ dataItem.valueDisplay}}</span>
                                            </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="vtOptionListDisplayColumns"></tr>
                                    <tr mat-row
                                        *matRowDef="let row; columns: vtOptionListDisplayColumns;"
                                        (click)="onRowClick(row)"
                                        [class.selected-row]="selectedRow === row">
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
